export const isMobile = () => window.innerWidth < 640

export const scrollToTop = () => {
  document.body.scrollTop = document.documentElement.scrollTop = 1
}



// WEBPACK FOOTER //
// ./src/services/index.js